<template>
  <div>
    <WdsButtonGhost secondary :href="path" :title="column?.name ?? ''" class="job-title-column">
      <span class="job-title-column__name">
        {{ column?.name ?? '' }}
      </span>
    </WdsButtonGhost>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsButtonGhost } from '@worksome/wds-components'
import { graphql, FragmentType, useFragment } from '@/gql'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'

const frag = graphql(`
  fragment JobTitleColumn on Job {
    id
    name
  }
`)

const props = defineProps<{
  row: FragmentType<typeof frag>
}>()

const column = computed(() => {
  if (!props.row) return null

  return useFragment(frag, props.row)
})

const path = computed(() => laravelNamedRoute('jobs.show', { job: column.value?.id }))
</script>

<style lang="scss">
.job-title-column {
  text-align: left;
  width: fit-content;
  width: 600px;

  &__name {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
